import {
  Button,
  Dialog,
  Box,
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Hidden
} from "@material-ui/core";
import { Quote } from "../../../../api/Quote/Quote";
import { TF } from "../../../../components/typography/TF";
import { useEffect, useState } from "react";
import ClearIcon from "@material-ui/icons/Clear";
import GetAppIcon from "@material-ui/icons/GetApp";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductSpecSheets } from "../../../../store/ProductSpecSheetSlice";
import { RootState } from "../../../../app/rootReducer";
import { useStyles } from "../../quoteDetail.styles";

interface Props {
  quote: Quote;
}

export const SpecSheets = ({ quote }: Props) => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [openSpecSheets, setOpenSpecSheets] = useState(false);

  const { specSheets } = useSelector((state: RootState) => state.specSheets);

  useEffect(() => {
    dispatch(fetchProductSpecSheets(quote.items.map((x) => x.productId)));
  }, [quote.items, dispatch]);

  if (!specSheets || specSheets.length === 0) {
    return <></>;
  }

  function formatFileSize(sizeInBytes: number) {
    const sizeInKilobytes = sizeInBytes / 1024;
    const sizeInMegabytes = sizeInKilobytes / 1024;

    if (sizeInMegabytes < 1) {
      return `${sizeInKilobytes.toFixed(0)} KB`;
    } else {
      return `${sizeInMegabytes.toFixed(1)} MB`;
    }
  }

  function getFileExtension(url: string): string {
    const pathname = new URL(url).pathname;
    const parts = pathname.split(".");
    return parts[parts.length - 1].toUpperCase();
  }

  return (
    <>
      <Button className={classes.btnLink2} onClick={() => setOpenSpecSheets(true)}>
        View Specifications
      </Button>
      <Dialog
        open={openSpecSheets}
        onClose={() => {
          setOpenSpecSheets(false);
        }}
        aria-labelledby="Summary-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <Box padding={"42px"}>
          <Box position={"absolute"} top="10px" right="20px">
            <IconButton
              onClick={() => {
                setOpenSpecSheets(false);
              }}
            >
              <ClearIcon />
            </IconButton>
          </Box>
          <Box>
            <Table padding="none" className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell style={{ padding: 10 }}>Name</TableCell>
                  <Hidden smDown>
                    <TableCell width={50}>Type</TableCell>
                    <TableCell width={80}>Size</TableCell>
                  </Hidden>
                  <TableCell width={50}>&nbsp;</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {specSheets?.map((s, i) => (
                  <TableRow key={i} className="asd">
                    <TableCell style={{ padding: 10 }}>
                      <TF>{s.name}</TF>
                    </TableCell>
                    <Hidden smDown>
                      <TableCell>
                        <TF>{getFileExtension(s.url)}</TF>
                      </TableCell>
                      <TableCell>
                        <TF>{formatFileSize(s.fileSize)}</TF>
                      </TableCell>
                    </Hidden>
                    <TableCell align="right" style={{ padding: 4 }}>
                      <IconButton href={s.url} target="_blank" style={{ padding: 6 }}>
                        <GetAppIcon color="secondary" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};
